export const ASSISTANT_EVENTS = {
	ASSISTANT_NAMESPACE: 'assistants',
	CREATE_ASSISTANT_CHAT: 'chat:create',
	CREATED_ASSISTANT_CHAT: 'chat:created',
};
